import ValidationRequestModal from './ValidationRequestModal';

export default ValidationRequestModal;
